module.exports = __webpack_public_path__ + "img/arrow-left.5bbb7439.svg";